import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { CModal, CModalHeader, CModalBody } from '@coreui/react';
import InviteByEmail from '../../Users/InviteByEmail/container';
import { createPortal } from 'react-dom';
import rolesObj from '../../../core/configs/roles';
import useUserRoles from '../../../core/hooks/useUserRoles';

const ShareReportModal = ({ show, onClose }) => {
  const { selectedReport } = useSelector(({ reports }) => reports);
  const { filteredRolesOptions: hookRolesOptions } = useUserRoles();

  const filteredRolesOptions = hookRolesOptions.filter(
    (role) =>
      role.id === rolesObj.reportViewer.name ||
      role.id === rolesObj.initiativeAdmin.name ||
      role.id === rolesObj.canvassingOrganizationUser.name ||
      role.id === rolesObj.electionOfficialAdmin.name,
  );

  const selectedReportType = selectedReport?.report_integration_type;

  const handleSubmit = () => {
    onClose();
  };

  const modalContent = (
    <CModal show={show} onClose={onClose} size="lg">
      <CModalHeader closeButton>Share Report</CModalHeader>
      <CModalBody>
        {selectedReportType === 'looker_studio' && (
          <p className="text-muted m-3">
            The invited user's email must be associated with a Google account.
          </p>
        )}
        <InviteByEmail
          title=""
          onSubmit={handleSubmit}
          Container={({ children }) => <div>{children}</div>}
          roles={filteredRolesOptions}
          withOnlyEmail
        />
      </CModalBody>
    </CModal>
  );

  return createPortal(modalContent, document.body);
};

ShareReportModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

ShareReportModal.defaultProps = {
  show: false,
  onClose: () => {},
};

export default ShareReportModal;
